import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

import './index.scss';

export default function AboutCards() {
  return (
    <Row className="align-items-stretch">
      <Col md={6}>
        <Card className="h-100 water-balance-culture-instruction-card">
          <Card.Header className="shadow-sm">
            SOBRE
          </Card.Header>
          <Card.Body>
            O balanço hídrico da cultura adapta o cálculo hidrológico à
            {' '}
            <strong>
              realidade das plantas,
            </strong>
            {' '}
            considerando a evapotranspiração real da cultura e a fração da água do solo
            efetivamente acessível às raízes em cada fase fenológica. Essa abordagem permite
            avaliar com mais precisão o
            {' '}
            <strong>
              estresse hídrico
            </strong>
            {' '}
            enfrentado pela lavoura, orientando melhor as decisões agronômicas. É possível
            consultar o balanço hídrico da cultura de forma
            {' '}
            <strong>
              pontual,
            </strong>
            {' '}
            analisando uma localidade e cultivo específicos.
          </Card.Body>
        </Card>
      </Col>
      <Col md={6}>
        <Card className="h-100 water-balance-culture-instruction-card">
          <Card.Header className="shadow-sm">
            INSTRUÇÕES PARA CONSULTA DO BALANÇO HÍDRICO
          </Card.Header>
          <Card.Body>
            Preencha as informações no painel de controle da aba
            {' '}
            <strong>Visão Detalhada</strong>
            :
            <div className="d-flex flex-row instruction-item m-1 mt-2">
              <div className="instruction-number instruction-marker me-2">1</div>
              <div className="instruction-text">Informe o local desejado.</div>
            </div>
            <div className="d-flex flex-row instruction-item m-1">
              <div className="instruction-number instruction-marker me-2">2</div>
              <div className="instruction-text">Informe a cultura (exemplo: soja, milho).</div>
            </div>
            <div className="d-flex flex-row instruction-item m-1">
              <div className="instruction-number instruction-marker me-2">3</div>
              <div className="instruction-text">Informe a data de emergência da cultura.</div>
            </div>
            <div className="d-flex flex-row instruction-item m-1">
              <div className="instruction-number instruction-marker me-2">4</div>
              <div className="instruction-text">Defina o intervalo de tempo para análise.</div>
            </div>
            <div className="d-flex flex-row instruction-item m-1 mb-2">
              <div className="instruction-number instruction-marker me-2">5</div>
              <div className="instruction-text">Escolha o tipo de solo (exemplo: argiloso, médio ou arenoso).</div>
            </div>
            <strong>OBS</strong>
            : A escolha do tipo de solo é opcional, caso não concordar com o valor de CAD
            definido automaticamente, de acordo com nosso banco de dados, para a localidade
            escolhida.
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}
